import $ from 'jquery'
import Cookies from 'js-cookie'
import MicroModal from 'micromodal'
import jump from 'jump.js'
import { modal_template } from './_modal-template'

const modal_identifier = 'modal-newsletter-signup'

const newsletter_content = `
<div class="row">
	<div class="medium-12 columns">
		<h2 class="text-center">Sign up for our Newsletter</h2>
		<p class="text-center">Stay informed of the latest commercial listings and commercial property news. Get the latest news.</p>
	</div>
	<div class="medium-6 columns">
		<p>
			<a
				class="text-center button secondary disable-click"
				id="take-user-to-newsletter-signup-form"
				data-micromodal-close
			>
				Sign Up
			</a>
		</p>
	</div>
	<div class="medium-6 columns">
		<p>
			<a
				class="text-center button secondary"
				data-micromodal-close
			>
				Dismiss
			</a>
		</p>
	</div>
</div>`

$('body').after(modal_template(newsletter_content, modal_identifier, modal_identifier))

$('#take-user-to-newsletter-signup-form').on('click', function () {
	jump('#global-site-newsletter-signup-form', {
		offset: -30,
		a11y: true,
	})
})

setTimeout(() => {
	$(document).on('mouseleave', function () {
		if (!Cookies.get('modal-newsletter-form')) {
			// eslint-disable-next-line no-unused-vars
			$('.modal').each(index => {
				MicroModal.close($(this).attr('id'))
			})

			MicroModal.show(modal_identifier, {
				onShow: () => {},
				onClose: (modal, element, event) => {
					Cookies.set('modal-newsletter-form', 'opened')
					if (event) {
						event.preventDefault()
						event.stopPropagation()
					}
				},
				disableScroll: true,
			})
		}
	})
}, 150000)
